import type { ReactNode } from 'react';

export const symbol_align_justify_space_around: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M640-290q-12.75 0-21.37-8.63Q610-307.25 610-320v-320q0-12.75 8.63-21.38Q627.25-670 640-670h40q12.75 0 21.38 8.62Q710-652.75 710-640v320q0 12.75-8.62 21.37Q692.75-290 680-290h-40Zm-360 0q-12.75 0-21.37-8.63Q250-307.25 250-320v-320q0-12.75 8.63-21.38Q267.25-670 280-670h40q12.75 0 21.38 8.62Q350-652.75 350-640v320q0 12.75-8.62 21.37Q332.75-290 320-290h-40ZM828.5-88.63Q820-97.25 820-110v-740q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v740q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63ZM109.82-80Q97-80 88.5-88.63 80-97.25 80-110v-740q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v740q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63Z"
		/>
	</svg>
);
